export function defaultPausaTimes(startTime: string, endTime: string) {
  if (startTime < "14:00" && "15:00" < endTime) {
    return { pausa_start_time: "14:00", pausa_end_time: "15:00" }
  }

  const start = toMinutes(startTime)
  const end = toMinutes(endTime)
  const span = end - start
  if (span < 90) {
    return { pausa_start_time: startTime, pausa_end_time: endTime }
  }

  const mid = Math.floor((start + end) / 2)
  const half = Math.min(30, Math.floor(span / 4))
  return {
    pausa_start_time: fromMinutes(mid - half),
    pausa_end_time: fromMinutes(mid + half),
  }
}

function toMinutes(value: string) {
  const [hours, minutes] = value.split(":").map(Number)
  return hours * 60 + minutes
}

function fromMinutes(total: number) {
  const hours = Math.floor(total / 60)
  const minutes = total % 60
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
}
